"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Narrative = exports.NarrativeStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_xhtml_1 = require("../Scalar/RTTI_xhtml");
var NarrativeStatusKind;
(function (NarrativeStatusKind) {
    NarrativeStatusKind["_generated"] = "generated";
    NarrativeStatusKind["_extensions"] = "extensions";
    NarrativeStatusKind["_additional"] = "additional";
    NarrativeStatusKind["_empty"] = "empty";
})(NarrativeStatusKind = exports.NarrativeStatusKind || (exports.NarrativeStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Narrative = t.recursion('INarrative', function () {
    return t.intersection([
        t.type({
            div: RTTI_xhtml_1.RTTI_xhtml
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            status: (0, EnumType_1.createEnumType)(NarrativeStatusKind, 'NarrativeStatusKind'),
            _status: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_Narrative.js.map